import { loadImages } from "../utils/importImages";

const babyImages = loadImages(
  require.context("./Images", false, /Bab\d+\.webp$/)
);

function BabyShoot() {
  return (
    <div id="scroll-container" className="scroll-container">
      <h2>Baby Shoot</h2>
      {babyImages.map((src, index) => (
        <img key={index} src={src} alt={`Baby ${index + 1}`} loading="lazy" />
      ))}
    </div>
  );
}

export default BabyShoot;
